import { isWithinCzechia } from './bounds.js';
/** Klice, ktere sdileny odkaz nese. Jine parametry stranky se nemeni. */
export const PLACE_LINK_KEYS = ['lat', 'lon', 'label'];
/** Delka popisku — delsi nekde nevejde a uz neni to „popisek". */
const MAX_LABEL_LENGTH = 120;
function numericParam(value) {
    if (typeof value === 'number')
        return Number.isFinite(value) ? value : null;
    if (typeof value !== 'string' || value.trim() === '')
        return null;
    const parsed = Number(value.trim());
    return Number.isFinite(parsed) ? parsed : null;
}
/**
 * Precte `?lat=&lon=&label=` z routeroveho search objektu.
 *
 * Vraci `null`, kdyz odkaz neni (chybí jedna ze souradnic, nejsou cisla,
 * bod je mimo CR). Chybny odkaz NESMI shodit stranku — mapa ma zustat
 * pouzitelna, jen bez predvyplneneho bodu.
 */
export function parsePlaceLink(search) {
    const lat = numericParam(search['lat']);
    const lon = numericParam(search['lon']);
    if (lat === null || lon === null)
        return null;
    if (!isWithinCzechia({ lat, lon }))
        return null;
    const rawLabel = search['label'];
    const label = typeof rawLabel === 'string' && rawLabel.trim() !== ''
        ? rawLabel.trim().slice(0, MAX_LABEL_LENGTH)
        : null;
    return { point: { lat, lon }, label };
}
/**
 * Slozi `mapa?lat=…&lon=…&label=…`.
 *
 * Souradnice jdou s plnou presnosti z cisla, ne zaokrouhlene — zaokrouhleni
 * na 5 desetin (asi metr) by pri plochem pozemku posunulo bod za hranici.
 * `label` se prida, jen kdyz neni prazdny.
 */
export function buildPlaceLink(pathname, place) {
    const params = new URLSearchParams();
    params.set('lat', String(place.point.lat));
    params.set('lon', String(place.point.lon));
    if (place.label !== null)
        params.set('label', place.label);
    const path = pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;
    return `${path}?${params.toString()}`;
}
//# sourceMappingURL=place-link.js.map